<template>
  <div :class="[classes, { 'scale-75 origin-center !-mt-1': activeWhenThenCursor }]">
    <DatePicker
      v-if="input_type == 'Date' || input_type == 'DateTime'"
      v-model="input_value"
      :relative-position="true"
      :is-dark="$store.state.ui.darkMode"
      tabindex="0"
      autofocus="1"
      :model-config="{
        type: 'string',
        mask: 'YYYY-MM-DD'
      }"
      class="w-full !h-full bg-white dark:bg-dark-screen-background"
      :popover="{ visibility: 'click' }">
      <template #default="{ inputValue, inputEvents }">
        <input :value="inputValue" class="form-input" :class="[inputClasses]" v-on="inputEvents">
      </template>
    </DatePicker>
    <QuarterDatePicker
      v-else-if="input_type == 'DateRange'"
      v-model:current-range="input_value"
      class="!bg-white"
      :relative-position="true" />

    <div
      v-else-if="input_type == 'date_extractor'"
      class="px-2 bg-yellow-400 rounded-full"
      :class="{ 'scale-75 origin-top': activeWhenThenCursor }">
      <div class="flex items-center gap-1 dark:text-white">
        <span class="px-1 font-semibold">{{ value.display }}(</span>
        <span class="px-1 font-semibold">+
          <input
            v-model="input_value"
            v-cleave="{
              numeral: true,
              numeralDecimalScale: dataType == 'Number' ? metric?.input_options?.decimal_places || 2 : 0,
              numeralThousandsGroupStyle: 'thousand'
            }"
            :placeholder="$t('Number of days')"
            :style="{ width: computed_width }"
            tabindex="0"
            autofocus="1"
            type="text"
            class="font-semibold text-center form-input"
            @focusin="handleFocusIn"
            @focusout="handleFocusOut">
        </span>
        <span class="px-1 font-semibold">)</span>
      </div>
    </div>

    <!-- To display Functions SUM/COUNT ..... and the input  -->
    <div v-else-if="input_type == 'function'" class="px-2 rounded-full origin-top w-full relative">
      <div class="w-full bg-[#2DA7D7] absolute h-10 z-0 -ml-2 rounded-full" />

      <div class="flex items-center gap-1 dark:text-white w-full relative z-10">
        <span class="px-1 font-semibold">{{ value.display }}(</span>
        <span class="px-1 font-semibold">
          <div class="text-xs relative h-0 top-3">{{ $t("Click here to select") }}</div>
          <div v-if="function_metric?.type == 'nested_metric'">
            <div :class="[{ ' pr-20': !function_metric }]" class="flex ml-4 items-center gap-1 dark:text-white rounded-full px-2 -pr-2 p-1">
              <div :class="[{ '!w-[90%]': itemIndex }]" class="bg-[#18328E] w-[60%] h-10 absolute z-0 -ml-6 rounded-full" />
              <span class="relative z-20 font-semibold text-white bg-[#4867D8] rounded-full m-1 p-1 px-3 right-4 h-8">{{ function_metric.display }}.</span>
              <span class="px-1 font-semibold relative z-10">
                <div
                  v-if="!nested_function_metric"
                  class="bg-white w-20 pointer-events-none text-xs mt-1 text-common-grey h-8 flex items-center justify-center absolute z-0 -ml-10 rounded-r-full pl-4">
                  {{ $t("Click to select") }}
                </div>
                <TransparentComboBoxInput
                  v-model="nested_function_metric"
                  :active-when-then-cursor="activeWhenThenCursor"
                  :class="[{ 'relative right-10 h-8': nested_function_metric }]"
                  :nested-metric="!!nested_function_metric"
                  :function-input="true"
                  :items="getNestedMetricsOptions(function_metric)"
                  :object-type="value.value?.object_type ? value.value?.object_type : value.value"
                  :is-last-input="true"
                  classes=""
                  :input-classes="`text-center `"
                  @remove="
                    () => {
                      nested_function_metric = null
                      input_value = null
                    }
                  "
                  @add="
                    (v) => {
                      nested_function_metric = v
                      input_value = v
                    }
                  " />
              </span>
            </div>
          </div>

          <TransparentComboBoxInput
            v-else
            v-model="function_metric"
            :class="{ 'ml-5': activeWhenThenCursor }"
            :active-when-then-cursor="activeWhenThenCursor"
            :function-input="true"
            :items="function_metric_options"
            :object-type="objectType"
            :is-last-input="true"
            classes=""
            :input-classes="`text-center `"
            @remove="
              () => {
                function_metric = null
                input_value = null
              }
            "
            @add="
              (v) => {
                handleAddFunctionMetric(v)
              }
            " />
        </span>
        <span class="px-1 font-semibold">)</span>
      </div>
    </div>

    <div v-else-if="input_type == 'nested_metric'">
      <div :class="[{ ' pr-20': !function_metric }]" class="flex items-center gap-1 dark:text-white rounded-full px-2 -pr-2 p-1">
        <div :class="[{ '!w-[90%]': itemIndex }]" class="bg-[#18328E] w-[85%] h-10 absolute z-0 -ml-6 rounded-full" />
        <span class="relative z-20 font-semibold text-white bg-[#4867D8] rounded-full m-1 p-1 px-3 right-4 h-8">{{ value.display }}.</span>
        <span class="px-1 font-semibold relative z-10">
          <div
            v-if="!function_metric"
            class="bg-white w-32 pointer-events-none text-xs mt-1 text-common-grey h-8 flex items-center justify-center absolute z-0 -ml-10 rounded-r-full pl-4">
            {{ $t("Click to select metric") }}
          </div>
          <TransparentComboBoxInput
            v-model="function_metric"
            :active-when-then-cursor="activeWhenThenCursor"
            :class="[{ 'relative right-10 h-8': function_metric }]"
            :nested-metric="!!function_metric"
            :function-input="true"
            :items="getNestedMetricsOptions(value)"
            :object-type="value.value?.object_type ? value.value?.object_type : value.value"
            :is-last-input="true"
            classes=""
            :input-classes="`text-center `"
            @remove="
              () => {
                function_metric = null
                input_value = null
              }
            "
            @add="
              (v) => {
                function_metric = v
                input_value = v
              }
            " />
        </span>
      </div>
    </div>

    <div v-else-if="input_type == 'Range'">
      <div class="flex items-center gap-1">
        <input
          v-model="input_range.start"
          v-bind="metric?.input_options"
          v-cleave="{
            numeral: true,
            numeralDecimalScale: dataType == 'Number' ? metric.input_options?.decimal_places || 2 : 0,
            numeralThousandsGroupStyle: 'thousand'
          }"
          :placeholder="$t('Greater Than')"
          tabindex="0"
          autofocus="1"
          :class="{ 'border-0 focus:ring-0 ring-0 -mt-1 bg-transparent': activeWhenThenCursor }"
          type="text"
          class="font-semibold text-center form-input"
          @focusin="handleFocusIn"
          @focusout="handleFocusOut">
        <span class="px-1 font-semibold dark:text-white">And</span>
        <input
          v-model="input_range.end"
          v-bind="metric?.input_options"
          v-cleave="{
            numeral: true,
            numeralDecimalScale: dataType == 'Number' ? metric.input_options?.decimal_places || 2 : 0,
            numeralThousandsGroupStyle: 'thousand'
          }"
          :class="{ 'border-0 focus:ring-0 ring-0 -mt-1 bg-transparent': activeWhenThenCursor }"
          placeholder="Less Than"
          tabindex="0"
          type="text"
          class="font-semibold text-center form-input"
          @focusin="handleFocusIn"
          @focusout="handleFocusOut">
      </div>
    </div>

    <select
      v-else-if="metric?.value == 'DateYear'"
      v-model="input_value"
      :class="{ 'border-0 focus:ring-0 ring-0 -mt-1 bg-transparent scale-75 origin-center': activeWhenThenCursor }"
      class="bg-light-box-background dark:bg-dark-box-background mx-1 mr-2 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue appearance-none text-left block w-full px-3 py-2.5 text-common-grey border border-light-divider-border dark:border-dark-divider-border rounded-lg shadow-sm">
      <option
        v-for="(_, i) in Array(500)"
        :key="i"
        :value="true"
        :class="['text-gray-900 dark:text-white appearance-none relative cursor-default py-2 pl-8 pr-4']">
        {{ 1900 + i }}
      </option>
    </select>

    <select
      v-else-if="metric?.value == 'DateMonth'"
      v-model="input_value"
      :class="{ 'border-0 focus:ring-0 ring-0 -mt-1 bg-transparent scale-75 origin-center': activeWhenThenCursor }"
      class="bg-light-box-background dark:bg-dark-box-background mx-1 mr-2 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue appearance-none text-left block w-full px-3 py-2.5 text-common-grey border border-light-divider-border dark:border-dark-divider-border rounded-lg shadow-sm">
      <option
        v-for="month in months"
        :key="month"
        :value="true"
        :class="['text-gray-900 dark:text-white appearance-none relative cursor-default py-2 pl-8 pr-4']">
        {{ month }}
      </option>
    </select>

    <select
      v-else-if="metric?.value == 'DateDay'"
      v-model="input_value"
      :class="{ 'border-0 focus:ring-0 ring-0 -mt-1 bg-transparent scale-75 origin-center': activeWhenThenCursor }"
      class="bg-light-box-background dark:bg-dark-box-background mx-1 mr-2 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue appearance-none text-left block w-full px-3 py-2.5 text-common-grey border border-light-divider-border dark:border-dark-divider-border rounded-lg shadow-sm">
      <option
        v-for="(_, i) in Array(31)"
        :key="i"
        :value="true"
        :class="['text-gray-900 dark:text-white appearance-none relative cursor-default py-2 pl-8 pr-4']">
        {{ i + 1 }}
      </option>
    </select>

    <select
      v-else-if="metric?.value == 'DateQuarter'"
      v-model="input_value"
      :class="{ 'border-0 focus:ring-0 ring-0 -mt-1 bg-transparent scale-75 origin-center': activeWhenThenCursor }"
      class="bg-light-box-background dark:bg-dark-box-background mx-1 mr-2 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue appearance-none text-left block w-full px-3 py-2.5 text-common-grey border border-light-divider-border dark:border-dark-divider-border rounded-lg shadow-sm">
      <option
        v-for="(_, i) in Array(4)"
        :key="i"
        :value="true"
        :class="['text-gray-900 dark:text-white appearance-none relative cursor-default py-2 pl-8 pr-4']">
        {{ i + 1 }}
      </option>
    </select>

    <input
      v-else-if="input_type == 'Number' && (metric?.reference_name == 'forecasts__grr' || metric?.reference_name == 'forecasts__nrr')"
      v-model="input_value"
      v-bind="metric?.input_options"
      onchange="if ((this.min && this.value < this.min) || (this.max && this.value > this.max)) { this.value = ''; }"
      :placeholder="$t('Type a number')"
      :style="{ width: computed_width }"
      :class="{ 'border-0 focus:ring-0 ring-0 -mt-1 bg-transparent': activeWhenThenCursor }"
      tabindex="0"
      autofocus="1"
      type="number"
      class="font-semibold text-center form-input w-fit"
      @focusin="handleFocusIn"
      @focusout="handleFocusOut">

    <input
      v-else-if="input_type == 'Number'"
      v-model="input_value"
      v-cleave="{
        numeral: true,
        numeralDecimalScale: dataType == 'Number' ? metric?.input_options?.decimal_places || 2 : 0,
        numeralThousandsGroupStyle: 'thousand'
      }"
      :placeholder="$t('Type a number')"
      :style="{ width: computed_width }"
      :class="{ 'border-0 focus:ring-0 ring-0 -mt-1 bg-transparent': activeWhenThenCursor }"
      tabindex="0"
      autofocus="1"
      type="text"
      class="font-semibold text-center form-input w-fit px-0"
      @focusin="handleFocusIn"
      @focusout="handleFocusOut">

    <select
      v-else-if="input_type == 'Boolean'"
      v-model="input_value"
      :class="{ 'border-0 focus:ring-0 ring-0 -mt-1 bg-transparent scale-75 origin-center': activeWhenThenCursor }"
      class="bg-light-box-background dark:bg-dark-box-background mx-1 mr-2 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue appearance-none text-left block w-full px-3 py-2.5 text-common-grey border border-light-divider-border dark:border-dark-divider-border rounded-lg shadow-sm">
      <option :value="true" :class="['text-gray-900 dark:text-white appearance-none relative cursor-default py-2 pl-8 pr-4']">
        {{ $t("Is Checked") }}
      </option>
      <option :value="false" :class="['text-gray-900 dark:text-white appearance-none relative cursor-default py-2 pl-8 pr-4']">
        {{ $t("Is Not Checked") }}
      </option>
    </select>

    <ComboBoxInput
      v-else-if="(input_type == 'String' || input_type == 'List') && metrics_with_options.includes(metric?.reference_name)"
      v-model:current-item="input_value"
      :relative-position="true"
      :class="{ 'border-0 focus:ring-0 ring-0 -mt-1 bg-transparent scale-75 origin-center': activeWhenThenCursor }"
      :items="metric.options"
      name="forecast_statuses"
      label-attr="label"
      value-attr="value"
      input-classes="w-full relative dark:text-white text-center  capitalize"
      classes="w-full relative dark:text-white text-center  shadow-none"
      :is-box-background="true"
      label=""
      :is-multiple="operator == 'in'"
      :show-label="false"
      :return-value="true"
      :floating-label="false"
      :allow-null="false"
      @focusin="handleFocusIn"
      @focusout="handleFocusOut" />

    <ComboBoxInput
      v-else-if="(input_type == 'String' || input_type == 'List') && metric?.reference_name == 'owner__email'"
      v-model:current-item="input_value"
      :class="{ 'border-0 focus:ring-0 ring-0 mt-1 bg-transparent origin-center': activeWhenThenCursor }"
      :items="metric.options"
      :relative-position="true"
      name="owner__email"
      label-attr="label"
      value-attr="value"
      input-classes="w-full relative dark:text-white text-center  capitalize"
      classes="w-full relative dark:text-white text-center "
      :is-box-background="true"
      label=""
      :is-multiple="operator == 'in'"
      :show-label="false"
      :return-value="true"
      :floating-label="false"
      :allow-null="false"
      @focusin="handleFocusIn"
      @focusout="handleFocusOut" />

    <ComboBoxInput
      v-else-if="(input_type == 'String' || input_type == 'List') && metric?.reference_name == 'tags__name'"
      v-model:current-item="input_value"
      :class="{ 'border-0 focus:ring-0 ring-0 -mt-1 bg-transparent scale-75 origin-center': activeWhenThenCursor }"
      name="tags"
      :relative-position="true"
      :items="$store.state.data.tags"
      label-attr="name"
      value-attr="name"
      :is-multiple="false"
      :allow-null="true"
      :return-value="true"
      label=""
      classes="w-full mr-2 relative dark:text-white"
      input-classes="sm:text-sm appearance-none font-medium text-gray-700 text-left block w-full py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light dark:border-dark-divider-border dark:bg-dark-box-background"
      selection-text=""
      :placeholder="$t('Select tag')"
      :floating-label="false"
      :show-label="false"
      @focusin="handleFocusIn"
      @focusout="handleFocusOut" />

    <input
      v-else-if="input_type == 'String'"
      v-model="input_value"
      :style="{ width: computed_width }"
      :placeholder="$t('Type word')"
      type="text"
      :class="{ 'border-0 focus:ring-0 ring-0 -mt-1 bg-transparent': activeWhenThenCursor }"
      class="form-input"
      @focusin="handleFocusIn"
      @focusout="handleFocusOut">

    <AutoCompleteInput
      v-else
      v-model="input_value"
      :class="{ 'border-0 focus:ring-0 ring-0 -mt-1 bg-transparent scale-75 origin-center': activeWhenThenCursor }"
      :is-async="true"
      :endpoint-async-url="`/api/organizations/${$store.state.organization.id}/metrics/${metricId}/suggestions/`"
      :placeholder="$t('Type word/s separated by comma')"
      separator=","
      :style="{ width: computed_width }"
      type="text"
      :icon="null"
      tabindex="0"
      autofocus="1"
      classes="p-0"
      :input-classes="`form-input `"
      @focusin="handleFocusIn"
      @focusout="handleFocusOut"
      @changed="
        ($event) => {
          input_value = $event
        }
      "
      @chosen="
        ($event) => {
          input_value = $event
        }
      " />
  </div>
</template>

<script>
import TransparentComboBoxInput from "@/views/dashboard/admin/metrics/formula-components/TransparentComboBoxInput.vue"
import AutoCompleteInput from "@/components/shared/AutoCompleteInput.vue"
import ComboBoxInput from "@/components/shared/ComboBoxInput.vue"
import QuarterDatePicker from "@/components/shared/QuarterDatePicker.vue"
import { consts } from "@/store/constants"
import { utils } from "@/store/helpers"
import { DatePicker } from "v-calendar"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    ComboBoxInput,
    TransparentComboBoxInput,
    QuarterDatePicker,
    DatePicker,
    AutoCompleteInput
  },
  props: {
    groupKeyRemoved: null,
    refId: null,
    activeWhenThenCursor: null,
    activeCursorIndex: null,
    value: null,
    metric: null,
    element: null,
    metricId: {
      type: String,
      required: true
    },
    dataType: {
      type: String,
      required: true
    },
    operator: {
      type: String,
      required: true
    },
    classes: {
      type: String,
      required: false,
      default: ""
    },
    inputClasses: {
      type: String,
      required: false,
      default: ""
    },
    objectType: {
      type: String,
      required: false,
      default: null
    },
    itemIndex: null
  },

  emits: ["update:modelValue", "remove"],
  data() {
    return {
      nested_function_metric: null,
      metrics: [],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      metrics_with_options: [
        "forecasts__forecast_status",
        "forecasts__forecast_type",
        "goals__status",
        "goals__type",
        "tasks__priority",
        "tasks__status",
        "plans__status",
        "plans__type",
        "interactions__category",
        "interactions__origin",
        "interactions__type",
        "goals__assigned_to__email",
        "tasks__assigned_to__email",
        "plans__collaborators__email"
      ],
      function_metric: null,
      function_metric_options: [],
      input_value: null,
      input_type: null,
      input_range: { start: null, end: null },
      forecast_and_base_metrics: [],
      input_focused: false
    }
  },
  computed: {
    computed_width() {
      let extra = this.dataType == "Number" ? 30 : 0
      extra = extra + !this.input_value ? 70 : 0

      return String(this.input_value)?.length ? `${String(this.input_value)?.length * 8 + 40 + extra}px` : "100%"
    }
  },
  watch: {
    groupKeyRemoved() {
      if (this.groupKeyRemoved == this.element?.group_key) {
        this.$emit("remove")
      }
    },
    input_value() {
      if (this.value?.type == "function") {
        this.$emit("update:modelValue", `${this.value.display}(${this.input_value ? this.input_value.reference_name : ""})`)
      } else if (this.value?.type == "date_extractor") {
        this.$emit("update:modelValue", `timedelta(${this.input_value})`)
      } else {
        this.$emit("update:modelValue", this.input_value)
      }
    },
    input_range: {
      deep: true,
      handler() {
        if (this.input_range.start && this.input_range.end) {
          this.$emit("update:modelValue", this.input_range)
        }
      }
    },

    operator: {
      deep: true,
      handler() {
        if (this.operator == "in" && (this.input_type == "Date" || this.input_type == "DateTime")) {
          this.input_type = "DateRange"
        }
      }
    }
  },

  created() {
    this.register_listeners()

    let forecasting_mappings =
      utils.find(this.$store.state.settings.modules_settings, { reference_code: "forecasting_mappings" })?.forecasting_mappings || []
    const forecasted_objects = forecasting_mappings.map((type_map) => {
      return this.$store.state.object_types.find((x) => x.id == type_map.object_type)?.type
    })

    if (this.value?.type == "function" || this.value?.type == "date_extractor") {
      this.input_type = this.value?.type
      this.metrics = utils
        .clone(this.$store.state.metrics)
        .map((x) => {
          x.name = x.object_type + " > " + x.name
          return x
        })
        .concat(consts.FORMULARY_OPTIONS.filter((x) => x.type == "forecast_metrics" || x.type == "other_metrics"))
    } else if (this.value?.type == "nested_metric") {
      this.input_type = "nested_metric"
    } else {
      this.input_value = utils.clone(this.value)
      this.input_type = utils.clone(this.dataType)
      if (this.operator == "in" && (this.input_type == "Date" || this.input_type == "DateTime")) {
        this.input_type = "DateRange"
      } else if (this.operator == "in" && this.input_type == "Number") {
        this.input_type = "Range"
      } else if (this.operator == "in" && this.input_type == "String" && this.metric.type == "forecast_metrics") {
        this.input_type = "List"
      } else if (this.operator == "==" && this.input_type == "Boolean" && this.metric.type == "metric") {
        this.input_type = "Boolean"
      }
    }

    if (forecasted_objects.includes(this.objectType)) {
      let forecasting_mappings_metrics = []
      let forecasting_mappings =
        utils.find(this.$store.state.settings.modules_settings, { reference_code: "forecasting_mappings" })?.forecasting_mappings || []
      forecasting_mappings.forEach((m) => {
        forecasting_mappings_metrics.push({
          key: utils.generateRandomKey(),
          type: "forecast_metrics",
          object_type: utils.getObjectTypeById(m.object_type)?.type,
          data_type: m.data_type,
          name: `Renewal Base (${m.name})`,
          display: `Renewal Base (${m.name})`,
          reference_name: `${m.reference_name}_renewal_base`,
          value: `${m.reference_name}_renewal_base`,
          label: `Renewal Base (${m.name})`
        })
        forecasting_mappings_metrics.push({
          key: utils.generateRandomKey(),
          type: "forecast_metrics",
          object_type: utils.getObjectTypeById(m.object_type)?.type,
          data_type: m.data_type,
          name: `Renewal Date (${m.name})`,
          display: `Renewal Date (${m.name})`,
          reference_name: `${m.reference_name}_renewal_date`,
          value: `${m.reference_name}_renewal_date`,
          label: `Renewal Date (${m.name})`
        })
      })

      let tags = this.$store.state.data.tags.map((t) => {
        t["label"] = t.name
        t["value"] = t.name
        return t
      })
      let owners = this.$store.state.data.users.map((m) => {
        m["label"] = m.full_name
        m["value"] = m.email
        return m
      })
      this.forecast_and_base_metrics = consts.FORMULARY_OPTIONS.concat(owners)
        .map((x) => {
          if (x.reference_name == "owner__email") {
            x["options"] = owners
          } else if (x.reference_name == "tags__name") {
            x["options"] = tags
          }
          return x
        })
        .concat(forecasting_mappings_metrics.filter((x) => (x?.object_type ? x.object_type == this.objectType : true)))
        .filter((x) => x.type == "forecast_metrics" || x.type == "metric")
    }
    this.forecast_and_base_metrics = this.forecast_and_base_metrics.concat(
      consts.FORMULARY_OPTIONS.filter((x) => x.type == "other_metrics")
    )

    if (this.value?.for && this.value?.for[0] == "Number") {
      this.function_metric_options = this.forecast_and_base_metrics
        .filter((f) => f.data_type == "Number")
        .concat(
          this.metrics.filter(
            (x) => x.object_type == this.objectType || (x.parent_object_type == this.objectType && this.input_type == "function")
          )
        )
        .filter((x) => !this.metrics_with_options.includes(x.reference_name))
    } else {
      this.function_metric_options = this.forecast_and_base_metrics
        .concat(
          this.metrics.filter(
            (x) => x.object_type == this.objectType || (x.parent_object_type == this.objectType && this.input_type == "function")
          )
        )
        .filter((x) => !this.metrics_with_options.includes(x.reference_name))
    }
  },
  methods: {
    handleAddFunctionMetric(v) {
      this.function_metric = v
      this.input_value = v
    },
    getNestedMetricsOptions(v) {
      return this.$utils.clone(this.$store.state.metrics.filter((m) => m.object_type == v.mapped_func))
    },
    handleFocusIn() {
      this.input_focused = true
      this.$emitter.emit(ALL_EMITTERS.SHOW_DROPDOWN_ACTIVE, true)
    },
    handleFocusOut() {
      this.input_focused = false
      this.$emitter.emit(ALL_EMITTERS.SHOW_DROPDOWN_ACTIVE, false)
    },
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.BACKSPACECLICKFORMULA, () => {
        if (
          !this.element?.group_key &&
          this.activeCursorIndex == this.itemIndex &&
          this.activeCursorIndex !== -1 &&
          (this.refId ? this.refId == this.activeWhenThenCursor : true)
        ) {
          setTimeout(() => {
            this.$emit("remove")
          }, 200)
        }
      })
    }
  }
}
</script>
